import type { ReactNode } from 'react';
import styles from '../Disco.module.css';
import { useTheme } from '../../../../../../hooks/useTheme';
import SlideableDrawerBanner from '../../../../../ui/SlideableDrawer/SlideableDrawerBanner';
import Dismiss from '../../../../../ui/Dismiss/Dismiss';
import type { EddHeaderContent } from '../hooks/useEddHeader';

interface EddDrawerProps {
  header: EddHeaderContent;
  delaySeconds: number;
  onDismiss: (source: 'button' | 'overlay' | 'swipe') => void;
  onOpen?: () => void;
  children: ReactNode;
}

export function EddDrawer({
  header,
  delaySeconds,
  onDismiss,
  onOpen,
  children,
}: EddDrawerProps) {
  const theme = useTheme();
  const background = theme.buttonsPrimaryDefault?.backgroundColor ?? '#111';
  const color = theme.buttonsPrimaryDefault?.color ?? '#fff';

  return (
    <SlideableDrawerBanner
      delaySeconds={delaySeconds}
      onDismiss={onDismiss}
      onOpen={onOpen}
      renderHeader={(dismiss) => (
        <div
          data-testid="edd-drawer-header"
          className={styles.eddDrawerHeader}
          style={{
            background,
            color,
            fontFamily: theme.bodytextDefaultNone?.fontFamily,
          }}
        >
          <div className={styles.eddDrawerGrabber} />
          <div className={styles.eddDrawerClose}>
            <Dismiss fill={color} onClick={dismiss} />
          </div>
          {header.noEddTitle && (
            <p className={styles.eddDrawerNoEddTitle}>{header.noEddTitle}</p>
          )}
          {header.status && (
            <p className={styles.eddDrawerStatus}>{header.status}</p>
          )}
          {header.edd && (
            <div
              className={styles.eddDrawerDate}
              aria-label={header.edd.ariaLabel}
            >
              <span aria-hidden="true">{header.edd.text}</span>
            </div>
          )}
          {header.orderNumber && (
            <p className={styles.eddDrawerOrder}>
              Order #<strong>{header.orderNumber}</strong>
            </p>
          )}
        </div>
      )}
    >
      <div className={styles.eddDrawerBody} style={{ background }}>
        <div className={styles.eddDrawerCard}>{children}</div>
      </div>
    </SlideableDrawerBanner>
  );
}
